import React, { useContext } from 'react'
import styles from "../../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import { Grid, Typography } from '@mui/material';
import GlobalButton from '../../../components/utility/globalButton/button';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { getApiKeyInformationArray } from '../utils';
import { CHRONOX_PUBLIC_API_KEYS_DOCUMENT_INFO } from '../constants';
import ApiKeyInfoCard from './apiKeyInfoCard';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getVendorCompanyName } from '../../../utils/constants';

const ApikeyInfo = () => {

    const onClickOfViewDocumentation = () => {
        window.open(CHRONOX_PUBLIC_API_KEYS_DOCUMENT_INFO['LINK'], "_blank");
    }

    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const companyName = getVendorCompanyName(vendorData);

    return (
        <>
            <Grid container gap={3}>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.justifyContentSpaceBetween}`} gap={2}>
                        <Grid item className={globalStyles.whiteSpaceWrap}>
                            <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.infoText}`}>
                                {`Create and manage API Keys to access ${companyName} services programmatically. Keep these keys safe.`}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <GlobalButton
                                className='borderedButtonStyle'
                                buttonText="View Documentation"
                                sx={{ width: "240px" }}
                                startIcon={<TextSnippetIcon />}
                                endIcon={<OpenInNewRoundedIcon />}
                                onClick={onClickOfViewDocumentation}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container gap={2}>
                        {getApiKeyInformationArray().map((item, index) => (
                            <Grid item xs={12} md key={index}>
                                <ApiKeyInfoCard
                                    icon={item.icon}
                                    title={item.title}
                                    description={item.description}
                                    iconColor={item.iconColor}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ApikeyInfo
